import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 46.001 85.999",
  "enable-background": "new 0 0 46.001 85.999",
  "aria-hidden": "true",
  focusable: "false"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.004 80.094c-1.338 1.35-1.338 3.54 0 4.893 1.337 1.35 3.506 1.352 4.845 0l39.148-39.54c1.338-1.35 1.338-3.542 0-4.894L5.848 1.013c-1.338-1.35-3.505-1.35-4.844 0-1.338 1.353-1.338 3.542 0 4.894L36.706 43 1.004 80.094z" }, null, -1)
  ])))
}
export default { render: render }